import React from 'react'
import { DocLayout } from 'smooth-doc/components'
import { unslugify } from 'unslugify'

const keyMatch = (data, key, nonexact = false) =>
  !!Object.keys(data).filter(k => (!nonexact ? k === key : k.includes(key))).length

export function PageWrapper({ children, props }) {
  const { data, pageContext } = props

  const strapiData =
    data &&
    Object.keys(data)
      .filter(k => k.toLowerCase().indexOf('strapi') !== -1)
      .map(k => data[k])

  const getTitle = () => {
    if (keyMatch(data, 'json')) return data.json.fields.title
    if (keyMatch(data, 'allJson')) return unslugify(pageContext.id)

    if (keyMatch(data, 'html')) return data.html.fields.title
    if (keyMatch(data, 'allHtml')) return unslugify(pageContext.id)

    if (keyMatch(data, 'strapi', true)) return strapiData[0].fields.title

    if (keyMatch(data, 'changelogs')) return 'Changelogs'
    return null
  }

  const title = getTitle()

  return title ? <DocLayout title={title}>{children}</DocLayout> : children
}
